<template>
  <Teleport to="body">
    <div class="fixed z-50 inset-0" v-show="open">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0">
        <div class="fixed inset-0 transition-opacity opacity-0" :class="{'ease-out duration-300 opacity-100' : open, 'ease-out duration-300' : !open}">
          <div class="absolute inset-0 bg-bhav-blue-400 opacity-60"></div>
        </div>
        <section class="relative max-h-[90vh] flex-0 flex flex-col align-bottom bg-white rounded-md text-left shadow-xl transform transition-all sm:my-8 sm:align-middle opacity-0"
                 :class="[{'px-4 pt-5 pb-4 sm:p-6': !noPadding}, {'sm:max-w-2xl lg:max-w-4xl w-full': !hideHeader && !isMap}, {'max-w-sm': hideHeader && !isMap}, {'w-auto': isMap}, {'ease-out duration-300 opacity-100 translate-y-0 sm:scale-100' : open}, $attrs.class]" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <header v-if="!hideHeader" class="flex-0 flex rounded-t-md text-bhav-blue-400 p-3 bg-bhav-cool-gray-50">
          <slot name="header"></slot>
          <button type="button"
                  class="ml-auto transition ease-in-out duration-150"
                  :class="{'bg-oakwood-gray-400 hover:text-oakwood-gray-500 focus:outline-none focus:text-oakwood-gray-500': !noPadding, 'bg-white w-8 h-8 rounded-md flex items-center text-xs justify-center text-bhav-blue-500 hover:bg-bhav-blue-50': noPadding}"
                  aria-label="Close"
                  @click.prevent="$emit('close', false)">
            <span class="fa fa-close"></span>
          </button>
        </header>
        <button v-else-if="isMap"
                type="button"
                class="absolute ml-auto -top-4 -right-4 transition ease-in-out duration-150 bg-bhav-blue-50 w-10 h-10 rounded-full flex items-center text-xs justify-center text-bhav-blue-500 hover:bg-bhav-blue-100"
                aria-label="Close"
                @click.prevent="$emit('close', false)">
          <span class="fa fa-close"></span>
        </button>
        <div :class="[{'sm:flex sm:items-start gap-4 flex-1 p-3': verticalScroll === 'overlap'}, {'sm:flex sm:items-start gap-4 flex-1 overflow-y-auto overflow-x-hidden p-3': verticalScroll === true}, {'sm:flex sm:items-start gap-4 flex-1 overflow-y-hidden overflow-x-hidden p-3': verticalScroll === false}]">
          <div v-if="icon"
               :class="{'text-oakwood-red-600' : icon == 'error'}"
               class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-oakwood-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <span class="fa text-xl" :class="{'fa-warning' : icon == 'error'}"></span>
          </div>
          <div class="text-center sm:mt-0 sm:text-left flex-1" :class="{'mt-3': !noPadding}">
            <div :class="{'mt-2': !noPadding}">
              <slot name="body"></slot>
            </div>
          </div>
        </div>
        <div v-if="$slots.buttons" class="flex justify-end gap-4 bg-white p-3  rounded-b-md">
          <slot name="buttons"></slot>
        </div>
        </section>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    icon: {
      default: false
    },
    isMap: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    verticalScroll: {
      type: [Boolean,String],
      default: true
    }
  }
}
</script>
